import React, { FC } from 'react'

// Plugins
import { Player, BigPlayButton } from 'video-react'

// Styles
import 'video-react/dist/video-react.css'

// Types
import { VideoProps } from './Video.types'

export const Video: FC<VideoProps> = ({ videoSrc, trackSrc, poster, autoPlay }) => {
  return (
    <Player playsInline fluid={true} preload='auto' src={videoSrc} poster={poster} seekable='false' autoPlay={autoPlay}>
      <BigPlayButton position='center' />
      {trackSrc && <track kind='captions' srcLang='en' src={trackSrc} label='English' default />}
    </Player>
  )
}
